export default defineNuxtPlugin(() => {
  if (process.client) {
    // Агрессивное удаление Service Worker
    const forceRemoveServiceWorker = async () => {
      if ('serviceWorker' in navigator) {
        try {
          // 1. Получаем все зарегистрированные Service Workers
          const registrations = await navigator.serviceWorker.getRegistrations()
          
          // 2. Удаляем все Service Workers
          for (const registration of registrations) {
            console.log('Удаляем Service Worker:', registration.scope)
            await registration.unregister()
          }
          
          // 3. Очищаем кэш Service Worker
          if ('caches' in window) {
            const cacheNames = await caches.keys()
            await Promise.all(
              cacheNames.map(cacheName => caches.delete(cacheName))
            )
            console.log('Очищен кэш Service Worker')
          }
          
          // 4. Принудительно обновляем страницу если Service Worker был активен
          if (navigator.serviceWorker.controller) {
            console.log('Service Worker был активен, обновляем страницу')
            window.location.reload()
            return
          }
          
          console.log('Service Worker полностью удален')
        } catch (error) {
          console.error('Ошибка при удалении Service Worker:', error)
        }
      }
    }
    
    // Запускаем удаление сразу
    forceRemoveServiceWorker()
    
    // Также запускаем при загрузке страницы
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', forceRemoveServiceWorker)
    } else {
      forceRemoveServiceWorker()
    }
    
    // Дополнительно запускаем через 2 секунды
    setTimeout(forceRemoveServiceWorker, 2000)
  }
})
